// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const u = await login(f.email, f.password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "client" ? "/dashboard" : "/admin");
    } catch (err) {
      toast.error(errMsg(err, "Login failed"));
    } finally { setBusy(false); }
  };

  const google = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2" data-testid="login-page">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1641998148499-cb6b55a3c0d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzg1NDYwMDU1fDA&ixlib=rb-4.1.0&q=85"
          className="absolute inset-0 w-full h-full object-cover opacity-70" alt=""/>
        <div className="absolute inset-0 bg-gradient-to-tr from-[#05050A] via-black/70 to-transparent"/>
        <div className="absolute bottom-10 left-10">
          <span className="label-mono">Craftora Studio</span>
          <div className="font-display font-black text-4xl mt-3 max-w-md leading-tight">Sign in to see your project in production.</div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-md">
          <Link to="/" className="label-mono">← Home</Link>
          <h1 className="font-display font-black text-4xl mt-4">Welcome back</h1>
          <p className="text-white/60 mt-2 text-sm">Sign in with email or continue with Google.</p>

          <input type="email" required placeholder="you@company.com" value={f.email}
            onChange={e=>setF({...f,email:e.target.value})}
            data-testid="login-email"
            className="w-full mt-8 bg-transparent hairline-strong rounded-lg px-4 py-3 outline-none focus:border-violet-500"/>
          <input type="password" required placeholder="Password" autoComplete="current-password" value={f.password}
            onChange={e=>setF({...f,password:e.target.value})}
            data-testid="login-password"
            className="w-full mt-3 bg-transparent hairline-strong rounded-lg px-4 py-3 outline-none focus:border-violet-500"/>

          <button disabled={busy} type="submit" className="pill-btn primary w-full justify-center mt-6" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>

          <div className="my-6 flex items-center gap-4 text-white/40 text-xs">
            <div className="flex-1 h-px bg-white/10"/> OR <div className="flex-1 h-px bg-white/10"/>
          </div>

          <button type="button" onClick={google} className="pill-btn ghost w-full justify-center" data-testid="login-google">
            <svg width="16" height="16" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.8 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.1 35.2 26.7 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.7 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.6l6.2 5.2C41 34.5 44 29.7 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
            Continue with Google
          </button>

          <div className="mt-8 text-sm text-white/60">
            No account? <Link to="/signup" className="text-white link-underline">Create one</Link>
          </div>
          <div className="mt-6 text-xs text-white/40 font-mono">
            
          </div>
        </form>
      </div>
    </div>
  );
}
